import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import CostCenterGroupConstants from "../Constants/CostCenterGroupConstants";

class CostCenterGroup_Action {
  getCostCenterGroupList() {
    httpRequest(
      config.webServiceURL + "/CostCenterGroup/GetCostCenterGroups",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.GET_COST_CENTER_GROUP_LIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveUpdateCostCenterGrp(costCenterGrp) {
    httpRequest(
      config.webServiceURL + "/CostCenterGroup/SaveOrUpdateCostCenterGroup",
      "POST",
      JSON.stringify({
        ...costCenterGrp,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.ADDORUPDATE_COST_CENTER_GROUP_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteCostCenterGroup(costCenterGroupID) {
    httpRequest(
      config.webServiceURL + "/CostCenterGroup/DeleteCostCenterGroup/",
      "DELETE",
      JSON.stringify([...costCenterGroupID]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: CostCenterGroupConstants.DELETE_COST_CENTER_GROUP_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new CostCenterGroup_Action();
